import api from '@/http';

export const fallbackSponsorFiles = [
  'Car Key Specialist and Locksmiths.jpeg',
  'Adrenalin.jpeg',
  'African Angling Adventures.jpeg',
  'Amanzi Plumbers.jpeg',
  'Angling Marine.jpeg',
  'Astron.jpeg',
  'Bottomline.jpeg',
  'Calaphi Wellnesss Studio.jpeg',
  'Chilly Pilly.jpeg',
  'Desai\'s Done Centre.jpeg',
  'Desai\'s Wholesalers.jpeg',
  'DR Y Mowzer.jpeg',
  'Fishing Freaks.jpeg',
  'Floors & Decor.jpeg',
  'FSA.jpeg',
  'FSA Sinkers.jpeg',
  'IV Gem Lounge.jpeg',
  'La Fiesta.jpeg',
  'Meat Locker.jpeg',
  'Paruk Optometrists.jpeg',
  'PE Woundcare & Nursing Services.jpeg',
  'Phoenix MMA.jpeg',
  'Radiant by Shakira.jpeg',
  'Spears.jpeg',
  'The Hidden Gem.jpeg',
  'Trend.jpeg',
  'Trophy Tackle Den.jpeg',
  'WinchBraid Fishing Line.jpeg',
  'Your Second Wife Pizza.jpeg',
  'Your Second Wife Takeaways.jpeg',
];

export const fallbackSponsors = fallbackSponsorFiles.map((file, index) => ({
  sponsorId: `fallback-${index}`,
  file,
  name: file.replace(/\.[^.]+$/, ''),
  displayOrder: index + 1,
  status: 'ACTIVE',
  linkUrl: '',
  instagramUrl: '',
  facebookUrl: '',
  tiktokUrl: '',
  whatsappNumber: '',
  emailAddress: '',
  src: `/sponsor-logos/${file}`,
}));

export function sponsorImageUrl(sponsor, thumbnail = true) {
  if (!sponsor?.sponsorId || String(sponsor.sponsorId).startsWith('fallback-')) {
    return sponsor?.src || '';
  }
  const baseUrl = api.defaults.baseURL || '';
  return `${baseUrl}rasspl/api/sponsors/image?sponsorId=${encodeURIComponent(sponsor.sponsorId)}&thumbnail=${thumbnail}`;
}

export async function loadPublicSponsors() {
  const response = await api.get('rasspl/api/sponsors/public');
  if (!response.data?.success) {
    throw new Error(response.data?.errorMessage || 'Unable to load sponsors.');
  }
  return (response.data.sponsors || []).map((sponsor) => ({
    ...sponsor,
    file: sponsor.sponsorId,
    src: sponsorImageUrl(sponsor, true),
  }));
}
